var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPython(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 84 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        fill-rule: evenodd;\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-4 {\n        fill: #e7f6fd;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 2395.3,
    y1: -713.7,
    x2: 2398.4,
    y2: -710.6,
    gradientTransform: "translate(-29931 8935.6) scale(12.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3a7fb9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#376a95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 2397.2,
    y1: -711.7,
    x2: 2400.6,
    y2: -708.5,
    gradientTransform: "translate(-29931 8935.6) scale(12.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fee053"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffc433"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: -1.9,
    y: -2.1,
    width: 87.8,
    height: 99.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4803.7-375.5h2500v2500h-2500V-375.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M41.4,7.2c-20,0-18.8,8.7-18.8,8.7v9h19.1v2.7H15s-12.8-1.5-12.8,18.7,11.2,19.5,11.2,19.5h6.7v-9.4s-.4-11.2,11-11.2h18.9s10.6.2,10.6-10.3v-17.3s1.6-10.5-19.3-10.5h0ZM30.8,13.2c1.9,0,3.4,1.5,3.4,3.4s-1.5,3.4-3.4,3.4-3.4-1.5-3.4-3.4h0c0-1.9,1.5-3.4,3.4-3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M41.9,85.6c20,0,18.8-8.7,18.8-8.7v-9h-19.1v-2.7h26.7s12.8,1.5,12.8-18.7-11.2-19.5-11.2-19.5h-6.7v9.4s.4,11.2-11,11.2h-18.9s-10.6-.2-10.6,10.3v17.3s-1.6,10.5,19.3,10.5h0ZM52.5,79.5c-1.9,0-3.4-1.5-3.4-3.4h0c0-1.9,1.5-3.4,3.4-3.4s3.4,1.5,3.4,3.4-1.5,3.4-3.4,3.4Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPython);
export default __webpack_public_path__ + "static/media/Python.0a140eb6d8580b33c0d3679859546cae.svg";
export { ForwardRef as ReactComponent };